// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e31a1328","744":"068748e3","801":"2cc73250"}[chunkId] + ".chunk.js";
};